const shopURL = document.currentScript.getAttribute('shop-url');
const pageTitle = document.currentScript.getAttribute('page-title');
const templateName = document.currentScript.getAttribute('template-name');

function getProductByHandleAndZipCode(handles){
    const zip_code = localStorage.getItem('_zipcode') ?? '';
    const handleArray = handles?.split(',') ?? [];
    
    $.ajax({
        url: "/apps/migraton/controller.php",
        type: "POST",
        data: { 
            action: 'get_featured_products',
            zip_code: zip_code,
            shop: Shopify.shop,
            handles: handles
        },
        success: function(data){
            const result = JSON.parse(data);
            if (result?.length > 0) {
                result.forEach(item => {
                    (document.querySelector(`.price_wrap[data-handle="${item.sp_handle}"]`) && document.querySelector(`.price_wrap[data-handle="${item.sp_handle}"]`).classList.toggle('hide'));
                    if(item?.product_type == "CONTAINER") {
                        if(item.final_compare_price > item.final_price && item.quantity != "0"){
                            document.querySelector(`.sale_price[data-handle="${item.sp_handle}"]`).innerHTML = `&#36;${formatNumberCustom((item.final_price).toFixed(2))}`;
                            document.querySelector(`.compare_price[data-handle="${item.sp_handle}"]`).innerHTML = `&#36;${formatNumberCustom((item.final_compare_price).toFixed(2))}`;
                        } else {
                            document.querySelector(`.sale_price[data-handle="${item.sp_handle}"]`).innerHTML = `&#36;${formatNumberCustom(((item.quantity == "0" && item.final_compare_price != 0 && item.final_compare_price > item.final_price) ? item.final_compare_price : item.final_price).toFixed(2))}`;
                            document.querySelector(`.compare_price[data-handle="${item.sp_handle}"]`).innerHTML = ``;
                        }
                    } else if(item?.product_type == "PORTABLE_STORAGE") {
                        if(item.final_compare_price > item.final_price && item.quantity != "0") {
                            if (item.final_price > 0) {
                                document.querySelector(`.sale_price[data-handle="${item.sp_handle}"]`).innerHTML = `&#36;${formatNumberCustom((item.final_price).toFixed(2))}`;
                                document.querySelector(`.compare_price[data-handle="${item.sp_handle}"]`).innerHTML = `&#36;${formatNumberCustom((item.final_compare_price).toFixed(2))}`;
                            }
                        } else {
                            let final_price = ((item.quantity == "0" && item.final_compare_price != 0 && item.final_compare_price > item.final_price) ? (item.final_compare_price + item?.assembly_product?.final_compare_price) : (item.final_price + item?.assembly_product?.final_price)).toFixed(2);
                            if(item?.customer_pickup_tag?.length > 0){
                                final_price = ((item.quantity == "0" && item.final_customer_pickup_compare_price != 0 && item.final_customer_pickup_compare_price > item.final_customer_pickup_price) ? (item.final_customer_pickup_compare_price) : (item.final_customer_pickup_price)).toFixed(2);
                            }
                            if (item.final_price > 0) {
                                document.querySelector(`.sale_price[data-handle="${item.sp_handle}"]`).innerHTML = `&#36;${formatNumberCustom(final_price)}`;
                                document.querySelector(`.compare_price[data-handle="${item.sp_handle}"]`).innerHTML = ``;
                            }
                        }
                    } else if(item?.product_type == "CUSTOM_CONTAINER") {
                        if(item.final_compare_price > item.final_price && item.quantity != "0") {
                            if (item.final_price > 0) {
                                document.querySelector(`.sale_price[data-handle="${item.sp_handle}"]`).innerHTML = `&#36;${formatNumberCustom((item.final_price).toFixed(2))}`;
                                document.querySelector(`.compare_price[data-handle="${item.sp_handle}"]`).innerHTML = `&#36;${formatNumberCustom((item.final_compare_price).toFixed(2))}`;
                            }
                        } else {
                            let final_price = ((item.quantity == "0" && item.final_compare_price != 0 && item.final_compare_price > item.final_price) ? (item.final_compare_price + item?.assembly_product?.final_compare_price) : (item.final_price + item?.assembly_product?.final_price)).toFixed(2);
                            if (item.final_price > 0) {
                                document.querySelector(`.sale_price[data-handle="${item.sp_handle}"]`).innerHTML = `&#36;${formatNumberCustom(final_price)}`;
                                document.querySelector(`.compare_price[data-handle="${item.sp_handle}"]`).innerHTML = ``;
                            }
                        }
                    }
                });
            }
        }   
    });
}

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? false : true;
        }
    }
};
  
var getUrlParameterForProduct = function getUrlParameterForProduct(sParam) {
    var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

function updateLinkData(_zipcode) {
    Array.from(document.getElementsByClassName('update-link open-location-modal update-location')).filter(e => e.innerHTML = _zipcode);
    $('[data-footer-btn]').text('Shop Now');
    $('[data-mobile-header-btn]').text('Shop Now');
    $('#submit_zipcode').val('Shop Now');
    $('#submit_zipcode_shipping_container_for_sale').val('Shop Now');
    $('.update-link.open-location-modal.update-location').addClass('active-zipcode');

    const locationCity  = localStorage.getItem('location_city') ?? '';
    $('#current-city').text(locationCity.replace(', USA', '').trim());
}

$(document).ready(function(){
    function getZipFromURL() {
  const params = new URLSearchParams(window.location.search);
  return params.get('zip');
}

var zipFromURL = getZipFromURL();

if (zipFromURL) {
  localStorage.setItem('_zipcode', zipFromURL);
}
    var _zipcode = getZipFromURL() || localStorage.getItem('_zipcode');

    $('.user-imput-zipcode').val(_zipcode);
    $("#userzipcode").val(_zipcode);
    $("#zipcodePopup").val(_zipcode);

    if(_zipcode) {
       updateLinkData(_zipcode);
    }

    $("#userzipcode").keypress(function(event) {
        if (event.which == '13') {
            event.preventDefault();
          
            var shop_url = shopURL;
            zipCode = jQuery('#userzipcode').val();
            localStorage.setItem("_zipcode",zipCode);
            updateLinkData(zipCode);
            window.location.href = zipCode?.length > 0 ? shop_url+'/pages/shop?zip='+zipCode+'&type=container&t='+Date.now() : shop_url+'/pages/shop';
        }
    });
    
    $("body").on("click","#submit_zipcode",function(){
        var shop_url = shopURL;
      
        zipCode = jQuery('#userzipcode').val();
        localStorage.setItem("_zipcode",zipCode);
        updateLinkData(zipCode);
        window.location.href = zipCode?.length > 0 ? shop_url+'/pages/shop?zip='+zipCode+'&type=container&t='+Date.now() : shop_url+'/pages/shop';
    });

    $("#user_zipcode_shipping_container_for_sale").keypress(function(event) {
        if (event.which == '13') {
            event.preventDefault();
          
            var shop_url = shopURL;
            zipCode = jQuery('#user_zipcode_shipping_container_for_sale').val();
            localStorage.setItem("_zipcode",zipCode);
            updateLinkData(zipCode);
            window.location.href = zipCode?.length > 0 ? shop_url+'/pages/shop?zip='+zipCode+'&type=container&t='+Date.now() : shop_url+'/pages/shop';
        }
    });

    $("body").on('click', '#submit_zipcode_shipping_container_for_sale', function(e) {   
       var shop_url = shopURL;
      
        zipCode = jQuery('#user_zipcode_shipping_container_for_sale').val();
        localStorage.setItem("_zipcode",zipCode);
        updateLinkData(zipCode);
        window.location.href = zipCode?.length > 0 ? shop_url+'/pages/shop?zip='+zipCode+'&type=container&t='+Date.now() : shop_url+'/pages/shop';
    });

    $("body").on("click","#shopNowBtnPopup",function(){
        var shop_url = shopURL;
      
        zipCode = jQuery('#zipcodePopup').val();
        localStorage.setItem("_zipcode",zipCode);
        updateLinkData(zipCode);
        const productType = getUrlParameterForProduct('type') == undefined ? 'container' : getUrlParameterForProduct('type');
        if (templateName == "product") {
            const newUrl = updateQueryStringParameterForProduct(location.href, 'zip_code', zipCode);
            window.history.replaceState({}, '', newUrl);
            location.reload();
        } else {
            window.location.href = zipCode?.length > 0 ? shop_url+'/pages/shop?zip='+zipCode+'&type='+productType : shop_url+'/pages/shop';
        }
    });

     $("#zipcodePopup").keypress(function(event) {
        if (event.which == '13') {
            event.preventDefault();
          
            var shop_url = shopURL;
            zipCode = jQuery('#zipcodePopup').val();
            localStorage.setItem("_zipcode",zipCode);
            updateLinkData(zipCode);
            const productType = getUrlParameterForProduct('type') == undefined ? 'container' : getUrlParameterForProduct('type');
            if (templateName == "product") {
                const newUrl = updateQueryStringParameterForProduct(location.href, 'zip_code', zipCode);
                window.history.replaceState({}, '', newUrl);
                location.reload();
            } else {
                window.location.href = zipCode?.length > 0 ? shop_url+'/pages/shop?zip='+zipCode+'&type='+productType : shop_url+'/pages/shop';
            }
        }
    });

    function userZipcode(){
        jQuery('.zip_error_msg').html('');
        zipCode = jQuery('#userzipcode').val();
        toStringZipcode = zipCode.toString();

        if(toStringZipcode.length == 0) {
            jQuery('.zip_error_msg').html("<span style='color:red; font-size: 14px;'>Zipcode should be valid US Zipcode.</span>");
            $(".zip_error_msg").show().delay(10000).fadeOut();
            return false;
        }else{
            data = {action:'check_zipcode',zip_code:zipCode};
            $.ajax({
                url: "/apps/migraton/controller.php",
                type: "POST",
                data:data,
                success: function(data){
                    if(data != 0){
                        var shop_url = shopURL;
                        jQuery('.zip_error_msg').html("");
                        localStorage.setItem("_zipcode",zipCode);
                        window.location.href = zipCode?.length > 0 ? shop_url+'/pages/shop?zip='+zipCode+'&type=container' : shop_url+'/pages/shop';
                    }else{
                        $(".woocommerce-products-header__title").text('');
                        $("#products_list").html('');
                        jQuery('.zip_error_msg').html("<span style='color:red; font-size: 14px;'>Zipcode should be valid US Zipcode.</span>");
                        $(".zip_error_msg").show().delay(10000).fadeOut();
                        setTimeout(function(){ $('#myModalb-error').modal('toggle'); }, 1000);
                    }
                }        
            });
            return false;
        }
    };

    $('body').on('click', '[data-footer-btn]', function(){
        const productType = getUrlParameterForProduct('type') == undefined ? 'container' : getUrlParameterForProduct('type');
        const zipCode = localStorage.getItem('_zipcode') ?? '';

        if(zipCode?.length > 0) {
            window.location.href = zipCode?.length > 0 ? '/pages/shop?zip='+zipCode+'&type='+productType : '/pages/shop';
        } else {
            $('html, body').animate({ scrollTop: $("#MainContent").offset().top }, 'slow');
        }
    });

    $('body').on('click', '[data-mobile-header-btn]', function(){
        const productType = getUrlParameterForProduct('type') == undefined ? 'container' : getUrlParameterForProduct('type');
        const zipCode = localStorage.getItem('_zipcode') ?? '';

        if(zipCode?.length > 0) {
            window.location.href = zipCode?.length > 0 ? '/pages/shop?zip='+zipCode+'&type='+productType : '/pages/shop';
        } else {
            if (document.querySelector(".open-location-modal")) {
                document.querySelector(".open-location-modal").click();   
            }
        }
    });

    const extractFeaturedProductHandles = () => {
        const elements = document.querySelectorAll('[data-featured-product-handle]');
        const handles = Array.from(elements).map(el => el.dataset.featuredProductHandle).filter(handle => handle && handle.trim()); // Filter out empty/whitespace values
        
        // Convert array to comma-separated string
        return handles.join(',');
    };    
    (Object.values(extractFeaturedProductHandles())?.length > 0) && (getProductByHandleAndZipCode(extractFeaturedProductHandles()));
});

function updateQueryStringParameterForProduct(url, key, value) {
    const urlObj = new URL(url);
    urlObj.searchParams.set(key, value);
    return urlObj.toString();
}
  
$(document ).ready(function() {
    // Read a page's GET URL variables and return them as an associative array.
    var utm_param = getUrlParameter('utm_source');  
    if(typeof utm_param != "undefined" && utm_param == true){
        var pageURL = window.location.href;
        setCookie('utm_source',pageURL,365);
    }
});

$(document).ready(function() { 
    var utm_param = getUrlParameter('utm_source');
    if(typeof utm_param != "undefined" && utm_param == true){
        var pageURL = window.location.href;
        setCookie('utm_source',pageURL,1);
        setCookie('pwp_url',pageURL,1);
    }

    // First time Leading in the site then set the default
    if(getCookie('pwp_url')=='' && getCookie('pwp_url').length==0){
        var page_title = pageTitle;
        if(page_title != 'Contact' && page_title != 'FAQ'){
            var pwp_link = window.location.href;
            setCookie('pwp_url',pwp_link,1);
        }
    }
});